import { combineReducers } from 'redux';
import { handleActions, combineActions } from 'redux-actions';
import * as actionTypes from './constants';

export const activeSort = handleActions(
  {
    [actionTypes.UPDATE_USERS_SORT]: (state, { payload }) => payload,
  },
  '',
);

export const activeSearchString = handleActions(
  {
    LOCATION_CHANGE: () => '',
    [actionTypes.UPDATE_SEARCH_STRING]: (state, { payload }) => payload,
  },
  '',
);

export const data = handleActions(
  {
    [combineActions(
      actionTypes.FETCH_SCOPED_USERS_REQUEST,
    )]: () => ({}),
    [actionTypes.FETCH_SCOPED_USERS_SUCCESS]: (state, { payload }) => ({
      data: payload.data,
      columnDefinitions: payload.columnDefinitions,
      totalDataCount: payload.totalDataCount,
    }),
    [actionTypes.FETCH_SCOPED_USERS_NEXT_SUCCESS]: (state, { payload }) => ({
      data: [...state.data, ...payload.data],
      columnDefinitions: payload.columnDefinitions,
      totalDataCount: payload.totalDataCount,
    }),
  },
  {},
);

export const isDataLoading = handleActions(
  {
    [combineActions(
      actionTypes.FETCH_SCOPED_USERS_SUCCESS,
      actionTypes.FETCH_SCOPED_USERS_FAILURE,
    )]: () => false,
    [combineActions(
      actionTypes.FETCH_SCOPED_USERS_REQUEST,
    )]: () => true,
  },
  false,
);

export const isNextDataLoading = handleActions(
  {
    [combineActions(
      actionTypes.FETCH_SCOPED_USERS_NEXT_SUCCESS,
      actionTypes.FETCH_SCOPED_USERS_NEXT_FAILURE,
    )]: () => false,
    [actionTypes.FETCH_SCOPED_USERS_NEXT_REQUEST]: () => true,
  },
  false,
);

export const next = handleActions(
  {
    [combineActions(
      actionTypes.FETCH_SCOPED_USERS_SUCCESS,
      actionTypes.FETCH_SCOPED_USERS_NEXT_SUCCESS,
    )]: (state, { payload }) => payload.next,
  },
  [],
);

export const roles = handleActions(
  {
    [combineActions(
      actionTypes.FETCH_SCOPED_USERS_SUCCESS,
    )]: (state, { payload }) => payload.roles,
  },
  [],
);

export const deleteSuccess = handleActions(
  {
    [combineActions(
      actionTypes.DELETE_USER_REQUEST,
      actionTypes.DELETE_USER_FAILURE,
    )]: () => false,
    [actionTypes.DELETE_USER_SUCCESS]: () => true,
  },
  false,
);

export const isDeleting = handleActions(
  {
    [combineActions(
      actionTypes.DELETE_USER_SUCCESS,
      actionTypes.DELETE_USER_FAILURE,
    )]: () => false,
    [actionTypes.DELETE_USER_REQUEST]: () => true,
  },
  false,
);

export const latestAddedUsers = handleActions(
  {
    [actionTypes.FETCH_SCOPED_USERS_REQUEST]: () => [],
    [actionTypes.ADD_USER_SUCCESS]: (state, { payload }) => [
      payload,
      ...state,
    ],
    [actionTypes.UPDATE_USER_SUCCESS]: (state, { payload }) => state?.map((x) => {
      if (x.id === payload.id) {
        return payload;
      }
      return x;
    }),
    [actionTypes.UPDATE_LATEST_ADDED_USERS]:
      (state, { payload }) => state?.filter(x => x.id !== payload),
  },
  [],
);

export const permissions = handleActions(
  {
    [actionTypes.GET_PERMISSIONS_SUCCESS]: (state, { payload }) => payload,
    [combineActions(
      actionTypes.GET_PERMISSIONS_REQUEST,
      actionTypes.GET_PERMISSIONS_FAILURE,
    )]: () => [],
  },
  [],
);

export const isAdding = handleActions(
  {
    [combineActions(
      actionTypes.ADD_USER_SUCCESS,
      actionTypes.ADD_USER_FAILURE,
    )]: () => false,
    [actionTypes.ADD_USER_REQUEST]: () => true,
  },
  false,
);

export const isUpdating = handleActions(
  {
    [combineActions(
      actionTypes.UPDATE_USER_SUCCESS,
      actionTypes.UPDATE_USER_FAILURE,
    )]: () => false,
    [actionTypes.UPDATE_USER_REQUEST]: () => true,
  },
  false,
);

export const error = handleActions(
  {
    [combineActions(
      actionTypes.FETCH_SCOPED_USERS_REQUEST,
      actionTypes.FETCH_SCOPED_USERS_SUCCESS,
      actionTypes.FETCH_SCOPED_USERS_NEXT_REQUEST,
      actionTypes.FETCH_SCOPED_USERS_NEXT_SUCCESS,
      actionTypes.ADD_USER_REQUEST,
      actionTypes.ADD_USER_SUCCESS,
      actionTypes.UPDATE_USER_REQUEST,
      actionTypes.UPDATE_USER_SUCCESS,
      actionTypes.DELETE_USER_REQUEST,
      actionTypes.DELETE_USER_SUCCESS,
      actionTypes.GET_PERMISSIONS_REQUEST,
      actionTypes.GET_PERMISSIONS_SUCCESS,
    )]: () => ({}),
    [combineActions(
      actionTypes.FETCH_SCOPED_USERS_FAILURE,
      actionTypes.FETCH_SCOPED_USERS_NEXT_FAILURE,
      actionTypes.ADD_USER_FAILURE,
      actionTypes.UPDATE_USER_FAILURE,
      actionTypes.DELETE_USER_FAILURE,
      actionTypes.GET_PERMISSIONS_FAILURE,
    )]: (state, { payload }) => payload.error,
  },
  {},
);

export default combineReducers({
  activeSort,
  activeSearchString,
  data,
  isDataLoading,
  isNextDataLoading,
  next,
  roles,
  deleteSuccess,
  isDeleting,
  latestAddedUsers,
  isAdding,
  isUpdating,
  permissions,
  error,
});
